import React from "react";

const Estrados = () => {
  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
        />

        <h3 className="bottom_title mt-5 enlaces-custom">
          Estrados Electrónicos
        </h3>

        <p
          className="text-center"
          style={{
            color: "#a90786",
            fontSize: "1.50rem",
            fontWeight: "700",
            marginBottom: "2px",
            marginTop: "0",
            paddingBottom: "0",
          }}
        >
          ¡Consúltalos aquí!
        </p>

        {/* 🔹 Botón unificado (círculo + mano dentro) */}
        <a
          href="/EstradosElectronicos"
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            background: "#a90786",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 0 0 rgba(169, 7, 134, 0.7)",
            animation: "pulse 2s infinite",
            textDecoration: "none",
            margin: "40px auto 0",
            cursor: "pointer",
            position: "relative",
          }}
          aria-label="Ir a Estrados Electrónicos"
        >
          <i
            className="bi bi-hand-index-thumb-fill"
            style={{
              fontSize: "3.5rem",
              color: "#FFDFC4",   // 👈 Aquí estableces el color crema
              animation: "pointing 1.2s infinite alternate",
              filter: "drop-shadow(2px 2px 2px rgba(0,0,0,0.3))",
            }}
            aria-hidden="true"
          ></i>
          <span style={{ display: "none" }}>Estrados Electrónicos</span>
        </a>

        <style>{`
          @keyframes pulse {
            0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(169, 7, 134, 0.7); }
            70% { transform: scale(1); box-shadow: 0 0 0 15px rgba(169, 7, 134, 0); }
            100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(169, 7, 134, 0); }
          }
          @keyframes pointing {
            0% { transform: translateY(0); }
            100% { transform: translateY(-6px); }
          }
        `}</style>
      </div>

      <div className="col-12 col-md-6 mt-4 mt-md-0">
        <h3 className="bottom_title mt-5 mb-5 enlaces-custom">Transparencia</h3>
        <div className="d-flex flex-column align-items-center gap-3">
          <a
            href="https://www.plataformadetransparencia.org.mx/"
            rel="noreferrer"
            className="w-100 text-center"
            aria-label="Plataforma Nacional de Transparencia"
          >
            <img
              src="https://itetlax.org.mx/assets/img/icons/e9.png"
              alt="Plataforma Nacional de Transparencia"
              className="img-fluid w-60 shadow rounded-4"
            />
          </a>
          <a
            href="http://consultapublicamx.inai.org.mx:8080/vut-web/?idSujetoObigadoParametro=5387&idEntidadParametro=29&idSectorParametro=24"
            rel="noreferrer"
            className="w-100 text-center"
            aria-label="Consulta Pública"
          >
            <img
              src="https://itetlax.org.mx/assets/img/icons/e10.png"
              alt="Consulta Publica"
              className="img-fluid w-60 shadow rounded-4"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Estrados;
